import {
	Component
} from '@angular/core'

@Component({
	selector: 'contact-complete',
	templateUrl: '../views/contact-complete.component.html'
})

export class ContactCompleteComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/contact-complete.component.ts